import { createFileRoute } from "@tanstack/react-router";
import PrivateSellLanding from "@/pages/PrivateSellLanding";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/vinde-masina/")({
  head: () => routeHead("/vinde-masina/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <PrivateSellLanding />
  );
}
